import microsoftLogo from '../assets/svg/achievements/microsoft.svg';
import metaLogo from '../assets/svg/achievements/meta.svg';

export const achievementData = {
  bio: "As a passionate Software Engineer with 4.5 Years of hands-on experience in Full-Stack Mobile Application & Web Development, I have successfully completed multiple projects using the MERN Stack. My expertise spans across React Native for mobile development, React.js for frontend applications, and comprehensive backend development with Node.js, Express, and various databases including MySQL, PostgreSQL, and MongoDB. I am skilled in modern web technologies like TypeScript, HTML5, CSS3, and have experience with cloud platforms like AWS. My commitment to continuous learning is demonstrated through professional certifications from Microsoft and META, and I thrive in collaborative environments where I can contribute to building scalable, efficient, and user-friendly applications.",
  achievements: [
    {
      id: 1,
      title: "Frontend Web Development by Microsoft",
      details:
        "Completed comprehensive frontend web development certification covering HTML5, CSS3, JavaScript ES6+, responsive design principles, accessibility standards, and modern web development tools. Gained expertise in building interactive user interfaces and optimizing web performance.",
      date: "February 16, 2024",
      field: "Web Development",
      image: microsoftLogo,
    },
    {
      id: 2,
      title: "Advance React - META",
      details:
        "Mastered advanced React concepts including hooks, context API, state management with Redux, server-side rendering with Next.js, performance optimization techniques, testing strategies with Jest and React Testing Library, and building scalable component architectures.",
      date: "September 20, 2023",
      field: "App Development",
      image: metaLogo,
    },
  ],
};
